module.exports = __webpack_public_path__ + "dcc4af08164965229fb2e3623e2f01c2.svg";